import type { AuthenticationContext } from '@connected/api-client/hooks/use-authentication';
import type { QueryClient } from '@tanstack/react-query';

import { Toaster } from '@connected/ui/components/sonner';
import { ThemeManager } from '@connected/ui/components/theme-manager';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { Confirmer } from '@/components/confirmer';
import { Devtools } from '@/components/dev-tools';
import { PWABadge } from '@/components/pwa-check';

export const Route = createRootRouteWithContext<AuthenticationContext<boolean | null> & {
    queryClient: QueryClient;
}>()({
    component: RootLayout,
    staticData: {
        theme: 'electrical',
    },
});

function RootLayout() {
    return (
        <>
            <ThemeManager />
            <Outlet />
            <Devtools />
            <Toaster />
            <PWABadge />
            <Confirmer />
        </>
    );
}
